export const locale = {
    lang: 'en',
    data: {
      'EDITOR': {
        'ACERCADE': 'Optionally, before creating the survey you can edit some characteristics of it, the changes made can be viewed within the survey once accessing it',
        'CONCAMBIOS': 'Changes to the survey configuration were detected, you must first generate the survey for the changes made to be applied, later you can complete the step',
        'CARGANDO': 'Loading information',
        'GUARDANDO': 'Saving changes',
        'CONFIGADICIONAL': {
          'TITULO': 'Additional configuration',
          'SUBTITULO': 'These settings apply to the survey for all languages',
          'DISPONIBLES': 'Available controls',
          'SAVEOK': 'The configuration was updated successfully',
          'CONTROLES': {
            'PIN': 'Enable survey protection with user PIN',
            'RANDOM': 'Enable the random validation question',
            'LIDERES': 'Show names of leaders (CEO / Boss) in statements\' perspectives'
          }
        },
        'ELEMENTOS': {
          'GUIA': 'Elements of this block',
          'COLORES': {
            'ORIGINAL': 'Unmodified element',
            'MODIFICADO': 'Modified element'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'No element has been modified',
            'MODIFICADO': 'One or more elements have been modified',
            'COMPLETO': 'All elements have been modified'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': 'There is no picture',
              'ACTUAL': 'Current image'
            },
            'TEXTO': {
              'INGRESAR': 'Enter your text'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Edit survey characteristics',
            'REGRESAR': 'Go back',
            'CONTINUAR': 'Continue',
            'CANCELAR': 'Cancel',
            'GUARDAR': 'Save Changes',
            'IMAGEN': 'Change image',
            'EDITOR': 'Edit message',
            'ELEMENTOS': 'Help',
            'ACTIVAR': 'Show',
            'DESACTIVAR': 'Hide',
            'ACEPTAR': 'Accept',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Login',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Broker logo',
                'ELEMENTOS': {
                  'logo': 'You can upload an image to change the broker\'s logo'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Previous instructions',
                'ELEMENTOS': {
                  'text': 'You can write the instructions to show before entering the survey'
                }
              },
              'LOGINFORM': {
                'TITULO': 'Login form',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': 'You can change the hint text for the "password" field',
                  'buttons_login_label': 'You can change the text of the login button',
                  'recoveryAccessKey_text': 'You can change the button text to recover password',
                }
              },
              'BACKGROUND': {
                'TITULO': 'Background image',
                'ELEMENTOS': {
                  'backgroudImage': 'You can change the background image that appears on this screen',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': 'Generic elements',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Broker logo',
                'ELEMENTOS': {
                  'logo': 'You can upload an image to change the broker\'s logo'
                }
              },
              'HEADER': {
                'TITULO': 'Header elements',
                'ELEMENTOS': {
                  'buttons_logout_label': 'You can change the text of the login button',
                  'header_logo': 'You can change the image of the system logo',
                  'isShowLastLogin_active': 'You can choose to show or hide the date of the last access',
                  'backgroundImage': 'You can change the background image that appears on this screen',
                  'header_showUserName': 'You can choose to show or hide the username'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': 'Welcome screen',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Screen content',
                'ELEMENTOS': {
                  'text': 'You can modify the content of the welcome screen',
                  'buttons_next_label': 'You can change the button text to continue',
                }
              },
              'LOGOUT': {
                'TITULO': 'Message when logging out',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'text': 'You can change the text of the message',
                  'buttons_cancel_label': 'You can change the button text to cancel the action',
                  'buttons_logout_label': 'You can change the text of the button to log out',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': 'Instruction screen',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Screen content',
                'ELEMENTOS': {
                  'text': 'You can modify the content of the instruction screen',
                  'buttons_previous_label': 'You can change the button text to go back',
                  'buttons_start_label': 'You can change the button text to start',
                  'buttons_continue_label': 'You can change the button text to continue',
                }
              },
              'LOGOUT': {
                'TITULO': 'Message when logging out',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'text': 'You can change the text of the message',
                  'buttons_cancel_label': 'You can change the button text to cancel the action',
                  'buttons_logout_label': 'You can change the text of the button to log out',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': 'Survey acceptance message',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': 'Activate the message to accept or reject the survey',
                'ELEMENTOS': {
                  'active': 'Activate pre-start message'
                }
              },
              'CONTENIDO': {
                'TITULO': 'Message content',
                'ELEMENTOS': {
                  'header_title': 'You can change the title of the message',
                  'text': 'You can change the content of the message',
                  'buttons_previous_label': 'You can change the button text to go back',
                  'buttons_acept_label': 'You can change the button text to reject the survey',
                  'buttons_cancel_label': 'You can change the button text to accept the survey'
                }
              },
              'LOGOUT': {
                'TITULO': 'Message when logging out',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'text': 'You can change the text of the message',
                  'buttons_cancel_label': 'You can change the button text to cancel the action',
                  'buttons_logout_label': 'You can change the text of the button to log out',
                }
              },
              'NOACEPT': {
                'TITULO': 'Message when rejecting the survey',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'text': 'You can change the text of the message',
                  'buttons_saveAndExit_label': 'You can change the button text to confirm and exit',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': 'Survey screen',
            'PASOS': {
              'NAV': {
                'TITULO': 'Navigation buttons',
                'ELEMENTOS': {
                  'buttons_next_label': 'You can change the button text to continue',
                  'buttons_previous_label': 'You can change the button text to go back',
                  'buttons_finish_label': 'You can change the button text to end the survey',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Instruction side panel',
                'ELEMENTOS': {
                  'button_label': 'You can change the button text to display the instruction panel',
                  'active': 'You can choose to show or hide the button on the instruction panel',
                  'text': 'You can modify the content of the instruction screen',
                }
              },
              'SOPORTE': {
                'TITULO': 'Side panel of support tips',
                'ELEMENTOS': {
                  'button_label': 'You can change the button text to display the support tips panel',
                  'active': 'You can choose to show or hide the support tips panel button',
                  'text': 'You can modify the content of the support tips screen',
                }
              },
              'COLUMNA1': {
                'TITULO': 'Statements: Perspective 1',
                'ELEMENTOS': {
                  'title': 'You can change the column title of perspective 1',
                  'tooltip_active': 'You can choose to show or hide the column title tooltip',
                  'tooltip_text': 'You can modify the content of the column title tooltip',
                }
              },
              'COLUMNA2': {
                'TITULO': 'Statements: Perspective 2',
                'ELEMENTOS': {
                  'title': 'You can change the column title of perspective 2',
                  'tooltip_active': 'You can choose to show or hide the column title tooltip',
                  'tooltip_text': 'You can modify the content of the column title tooltip',
                }
              },
              'FINISH_1': {
                'TITULO': 'Message at the end of the survey',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'textAnswered': 'You can modify the text of the message displayed when answering all the questions',
                  'textNotAnswered': 'You can modify the text of the displayed message by not answering all the questions',
                  'textFooter': 'You can modify the text of the message',
                  'buttons_previous_label': 'You can change the button text to go back',
                  'buttons_close_label': 'You can change the button text to end the survey',
                }
              },
              'FINISH_2': {
                'TITULO': 'Message after completing the survey',
                'ELEMENTOS': {
                  'windowFinishMessage_title': 'You can change the title of the message',
                  'windowFinishMessage_text': 'You can modify the text of the message',
                  'windowRanking_active': 'You can choose to show or hide the message to rate the survey',
                  'windowRanking_text': 'You can modify the text of the message to rate the survey',
                  'windowFinishMessage_buttons_close_label': 'You can change the button text to continue',
                }
              },
              'LOGOUT_1': {
                'TITULO': 'Message when logging out',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'text': 'You can modify the text of the message',
                  'textBandRequired': 'You can modify the text of the irreversibility warning message',
                  'buttons_previous_label': 'You can change the button text to cancel the action',
                  'buttons_saveAndExit_label': 'You can change the button text to save changes and log out',
                }
              },
              'LOGOUT_2': {
                'TITULO': 'Message after logging out',
                'ELEMENTOS': {
                  'title': 'You can change the title of the message',
                  'text': 'You can modify the text of the message',
                  'buttons_close_label': 'You can change the button text to continue',
                }
              },
            }
          },
        }
      }
    }
};
